import { EditAnscNotificationsCancellationsCrumbs } from 'cancellations/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import EditAnscNotificationsShared from 'shell/components/shared/ansc-notifications/edit';
import { IdAmbito } from 'shell/constants/id-ambito';

const AnscNotificationsEditPage = (): ReactElement => {
  return (
    <Fragment>
      <EditAnscNotificationsShared
        scope={IdAmbito.Cancellazioni}
        items={EditAnscNotificationsCancellationsCrumbs()}
      />
    </Fragment>
  );
};

AnscNotificationsEditPage.displayName = 'Ansc Notification edit page component';

export default AnscNotificationsEditPage;
